import { MediaFeatureModel } from '../../../../fetch-data/graphql';

export const isVideo = (media?: MediaFeatureModel) => {
  if (!media?.asset?._publishUrl && !media?.externalUrl) return false;

  // Check if type indicates video
  const type = media?.asset?.type?.toLowerCase();
  if (type && (type.includes('video') || type === 'multimedia')) {
    return true;
  }

  // Check URL extension as fallback
  const url = media?.asset?._publishUrl || media?.externalUrl;
  if (!url) return false;

  const urlLower = url.toLowerCase();

  // Check for YouTube links
  if (isYouTubeUrl(url)) return true;

  // Check for video file extensions
  const videoExtensions = ['.mp4', '.mov', '.webm', '.ogg', '.avi', '.m4v'];
  return videoExtensions.some((ext) => urlLower.endsWith(ext));
};

export const isValidMedia = (media?: MediaFeatureModel) => {
  if (!media) return false;

  return Boolean(media.asset?._publishUrl || media.externalUrl);
};

export const isYouTubeUrl = (url?: string | null): boolean => {
  if (!url) return false;
  const urlLower = url.toLowerCase();
  return (
    urlLower.includes('youtube.com/watch') ||
    urlLower.includes('youtu.be/') ||
    urlLower.includes('youtube.com/embed/') ||
    urlLower.includes('m.youtube.com/watch')
  );
};

export const convertToYouTubeEmbedUrl = (url: string): string => {
  if (!isYouTubeUrl(url)) return url;

  // Extract video ID from various YouTube URL formats
  let videoId = '';

  // Handle youtu.be/VIDEO_ID
  if (url.includes('youtu.be/')) {
    videoId = url.split('youtu.be/')[1]?.split('?')[0] || '';
  }
  // Handle youtube.com/watch?v=VIDEO_ID
  else if (url.includes('youtube.com/watch')) {
    const match = url.match(/[?&]v=([^&]+)/);
    videoId = match ? match[1] : '';
  }
  // Handle youtube.com/embed/VIDEO_ID
  else if (url.includes('youtube.com/embed/')) {
    videoId = url.split('youtube.com/embed/')[1]?.split('?')[0] || '';
  }

  if (!videoId) return url;

  // Build embed URL with optional autoplay
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  return embedUrl;
};
